import { useMemo } from 'react';
import { getEmployeePockets } from '@/common/integrations/menhir/employee/pockets/pockets.service';
import { IPocket } from '@/common/integrations/menhir/employee/pockets/pockets.types';
import { MENHIR_ENDPOINTS } from '@/common/integrations/menhir/menhir.endpoints';
import { QueryOptions, useQuery } from '@tanstack/react-query';

export function useGetPockets(
  options?: QueryOptions<IPocket[], any, IPocket[]>
) {
  const { data: pockets, ...rest } = useQuery({
    queryKey: [MENHIR_ENDPOINTS.EMPLOYEE.POCKETS],
    queryFn: getEmployeePockets,
    ...options,
  });

  const benefitsPocket = useMemo(
    () => pockets?.find((pocket) => pocket.type === 'benefits'),
    [pockets]
  );
  const mealPocket = useMemo(
    () =>
      pockets?.find(
        (pocket) => pocket.type === 'meals' || pocket.type === 'meal-voucher'
      ),
    [pockets]
  );
  const creditsPocket = useMemo(
    () => pockets?.find((pocket) => pocket.type === 'credits'),
    [pockets]
  );

  const fringePocket = useMemo(
    () => pockets?.find((pocket) => pocket.type === 'fringe'),
    [pockets]
  );

  return {
    loading: rest.isInitialLoading,
    pockets,
    benefitsPocket,
    mealPocket,
    creditsPocket,
    fringePocket,
    refresh: rest.refetch,
    ...rest,
  };
}
